<template>
    <div class="content survey">
        <div class="tit_area">
            <p class="tit">{{title}}</p>
        </div>

        <div class="tbl_cell complete_txt_area" style="padding-bottom: 0">
            <button type="button" class="btn_complete" style="margin-top: 0" v-if="isAllowEdit"
                    @click="editCoronaResponse">{{$t('CoronaResponseResult_again')}}
            </button>
        </div>

        <div v-if="!needNoticeCoronaResponseResult" class="articleViewer">
            <span style="font-weight: bold; font-size: 22px;">{{$t('CoronaResponseResult_notice')}}</span>
            <p>{{$t('CoronaResponseResult_descNotice')}}</p>
        </div>
        <div v-else class="articleViewer">
            <span style="font-weight: bold; font-size: 22px;">{{isPassText}}</span>
            <template v-if="isPass">
                <p>{{$t('CoronaResponseResult_descPass')}}</p>
            </template>
            <template v-else>
                <p>{{$t('CoronaResponseResult_descNoPass1')}}</p>
                <p>{{$t('CoronaResponseResult_descNoPass2')}}</p>
                <p>{{$t('CoronaResponseResult_descNoPass3')}}</p>
            </template>
        </div>

        <div class="after_tit_area" v-if="isWebView" style="margin-top: 20px;">
            <form action="#" onsubmit="return false">
                <fieldset>
                    <div class="btn_area"
                         style="margin-top: 0; width: 90%;bottom: 40px;margin: 0 auto;left: 0;right: 0;">
                        <button type="button" class="btn" @click="complete">{{$t('common_confirm')}}</button>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
    import {schema} from '@/common/utils/webview.js';

    export default {
        name: 'CoronaResponseResult',
        props: {
            title: {
                type: String,
                required: true,
            },
            isPass: {
                type: Boolean,
                required: true,
            },
            isWebView: {
                type: Boolean,
                required: true,
            },
            isAllowEdit: {
                type: Boolean,
                required: true,
            },
            needNoticeCoronaResponseResult: {
                type: Boolean,
                required: true,
            },
        },

        computed: {
            isPassText() {
                if (this.isPass) {
                    return this.$t('CoronaResponseResult_pass');
                }
                return this.$t('CoronaResponseResult_noPass');
            }
        },

        methods: {
            complete() {
                schema('webview', 'complete');
            },

            editCoronaResponse() {
                this.$emit('editCoronaResponse');
            },
        }
    };
</script>

<style scoped>
    p {
        margin: 15px 0;
    }
</style>
